module.exports = __webpack_public_path__ + "img/20190723144545204.5b789535.png";